/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  const createCustomerForm = document.querySelector('#CreateCustomer');
  const registerLoadingSpinner = document.querySelector('[data-loading-spinner]');

  if (createCustomerForm) {
    // Create Customer Request
    createCustomerForm.addEventListener('submit', (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      createCustomerForm.querySelector('button[type="submit"]').disabled = true;

      registerLoadingSpinner.classList.add('is-visible');

      // Extract the value of customer[note][Loyalty Card]
      const formData = new FormData(createCustomerForm);
      const loyaltyCardValue = formData.get('customer[note][Loyalty Card]');
      const formFirstName = formData.get('customer[first_name]');
      const formLastName = formData.get('customer[last_name]');
      const formEmail = formData.get('customer[email]');
      const formPhone = formData.get('customer[phone]');

      // createCustomerForm.querySelector('[data-tag-phone]').value = `phone_number:${formPhone}`;

      if (loyaltyCardValue === 'on') {
        // Send a POST request to Ivan to create the card
        //https://apps.gloross.com/Alchemista/CreatePromoCard
        fetch(
          `https://apps.gloross.com/Alchemista/CreatePromoCard?email=${formEmail}&phone=${formPhone}&name=${
            formFirstName + ' ' + formLastName
          }&location=register`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )
          .then((response) => response.json())
          .then((data) => {
            registerLoadingSpinner.classList.remove('is-visible');
          })
          .catch((error) => {
            console.error('Error:', error);
          });

        createCustomerForm.submit();
      } else {
        createCustomerForm.submit();
      }

      // Submit the form programmatically after custom logic
    });
  }

  const getLoyaltyCardButton = document.querySelector('[data-get-loyalty-card]');
  const createLoyaltyCardForm = document.querySelector('[data-create-loyalty-card]');

  const loyaltyCardPopup = document.querySelector('[data-loyalty-card-popup]');
  const loyaltyCardPopupCloseBtn = document.querySelector('[data-loyalty-card-close]');
  const loyaltyCardImage = document.querySelector('[data-loyalty-card-image]');
  const loyaltyCardDownloadImage = document.querySelector('[data-loyalty-card-download]');
  const loyaltyCardAppleWallet = document.querySelector('[data-loyalty-card-apple-wallet]');
  const loyaltyCardGoogleWallet = document.querySelector('[data-loyalty-card-google-wallet]');
  const loyaltyCardNumber = document.querySelector('[data-loyalty-card-number]');
  const loyaltyCardPoints = document.querySelector('[data-loyalty-card-points]');
  const loadingSpinner = document.querySelector('[data-loading-spinner]');

  const loyaltyCardSuccess = document.querySelector('[data-loyalty-card-success]');
  const loyaltyCardFail = document.querySelector('[data-loyalty-card-fail]');

  const popupOverlay = document.querySelector('[data-popup-overlay]');

  if (getLoyaltyCardButton) {
    let customerEmail;
    let loyaltyCardBarcode;

    // GetPromoCard Request
    const closePopup = (e) => {
      e.preventDefault();

      themeVendor.ScrollLock.clearQueueScrollLocks();
      themeVendor.ScrollLock.enablePageScroll();
      document.documentElement.removeAttribute('data-scroll-locked');

      loyaltyCardPopup.classList.remove('is-visible');
      popupOverlay.classList.remove('is-visible');
    };

    popupOverlay.addEventListener('click', closePopup);
    loyaltyCardPopupCloseBtn.addEventListener('click', closePopup);

    const customerFirstNameData = getLoyaltyCardButton.dataset.customerFirstName || 'Име';
    const customerLastNameData = getLoyaltyCardButton.dataset.customerLastName || 'Фамилия';

    getLoyaltyCardButton.addEventListener('click', (e) => {
      e.preventDefault();

      customerEmail = e.target.dataset.customerEmail;
      customerPhone = e.target.dataset.customerPhone;

      const encodedEmail = encodeURIComponent(customerEmail);
      loadingSpinner.classList.add('is-visible');

      themeVendor.ScrollLock.disablePageScroll();
      document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: loyaltyCardPopup}));

      console.log(encodedEmail);

      // Send a POST request to get the card
      fetch(`https://apps.gloross.com/Alchemista/GetPromoCard?email=${encodedEmail}&phone=${customerPhone}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data) {
            loadingSpinner.classList.remove('is-visible');
            popupOverlay.classList.add('is-visible');
            loyaltyCardPopup.classList.add('is-visible');

            if (data.result == false) {
              loyaltyCardSuccess.classList.remove('is-visible');
              loyaltyCardFail.classList.add('is-visible');

              createLoyaltyCardForm.addEventListener('submit', (e) => {
                e.preventDefault();

                createLoyaltyCardForm.querySelector('button[type="submit"]').disabled = true;

                loadingSpinner.classList.add('is-visible');

                const formData = new FormData(createLoyaltyCardForm);
                const customerPhone = formData.get('phone');
                const customerFirstName = formData.get('first_name');
                const customerLastName = formData.get('last_name');

                fetch(
                  `https://apps.gloross.com/Alchemista/CreatePromoCard?email=${encodedEmail}&phone=${customerPhone}&name=${
                    customerFirstName + ' ' + customerLastName
                  }&location=accountPage`,
                  {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                    },
                  }
                )
                  .then((response) => response.json())
                  .then((data) => {
                    console.log('Success:', data);
                  })
                  .then(() => {
                    // Fetch the promo card again
                    fetch(
                      `https://apps.gloross.com/Alchemista/GetPromoCard?email=${encodedEmail}&phone=${customerPhone}`,
                      {
                        method: 'POST',
                        headers: {
                          'Content-Type': 'application/json',
                        },
                      }
                    )
                      .then((response) => response.json())
                      .then((data) => {
                        console.log('Success:', data);
                        loyaltyCardBarcode = data.cardNumber;

                        loadingSpinner.classList.remove('is-visible');
                        loyaltyCardSuccess.classList.add('is-visible');
                        loyaltyCardFail.classList.remove('is-visible');

                        loyaltyCardImage.setAttribute('src', `data:image/png;base64,${data.imageBase64}`);
                        loyaltyCardDownloadImage.setAttribute('href', `data:image/png;base64,${data.imageBase64}`);
                        loyaltyCardNumber.textContent = data.cardNumber;
                        loyaltyCardPoints.textContent = data.points;
                      })
                      .catch((error) => {
                        console.error('Error:', error);
                      });
                  })
                  .catch((error) => {
                    console.error('Error:', error);
                  });
              });
            } else {
              loyaltyCardBarcode = data.cardNumber; // Assign barcode here
              loyaltyCardSuccess.classList.add('is-visible');
              loyaltyCardFail.classList.remove('is-visible');

              loyaltyCardImage.setAttribute('src', `data:image/png;base64,${data.imageBase64}`);
              loyaltyCardDownloadImage.setAttribute('href', `data:image/png;base64,${data.imageBase64}`);
              loyaltyCardNumber.textContent = data.cardNumber;
              loyaltyCardPoints.textContent =
                data.points + ` (${themeVendor.themeCurrency.formatMoney(data.points / 0.2, theme.moneyFormat)})`;
            }
          }
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    });

    loyaltyCardGoogleWallet?.addEventListener('click', (e) => {
      e.preventDefault();

      if (loyaltyCardBarcode) {
        fetch(
          `https://apps.gloross.com/Alchemista/GetGoogleWalletCardUrl?barcode=${loyaltyCardBarcode}&customerName=${
            customerFirstNameData + ' ' + customerLastNameData
          }
          `,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )
          .then((response) => response.json())
          .then((data) => {
            if (data.redirectUrl) {
              window.open(data.redirectUrl, '_blank');
            } else {
              console.log('Success:', data);
            }
          })
          .catch((error) => {
            console.error('Error:', error);
          });
      } else {
        console.error('loyaltyCardBarcode is not defined');
      }
    });

    loyaltyCardAppleWallet?.addEventListener('click', (e) => {
      e.preventDefault();

      if (loyaltyCardBarcode) {
        fetch(
          `https://apps.gloross.com/Alchemista/GetAppleWalletCard?barcode=${loyaltyCardBarcode}&customerName=${
            customerFirstNameData + ' ' + customerLastNameData
          }`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )
          .then((response) => response.json())
          .then((data) => {
            if (data.success) {
              const {data: fileData, fileName, contentType} = data;

              // Create a Blob from the data
              const byteCharacters = atob(fileData);
              const byteNumbers = new Array(byteCharacters.length);
              for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
              }
              const byteArray = new Uint8Array(byteNumbers);
              const blob = new Blob([byteArray], {type: contentType});

              // Create a URL for the Blob
              const url = URL.createObjectURL(blob);

              // Create an anchor element and trigger the download
              const a = document.createElement('a');
              a.href = url;
              a.download = fileName;
              document.body.appendChild(a);
              a.click();

              // Clean up
              document.body.removeChild(a);
              URL.revokeObjectURL(url);
            } else {
              console.error('Failed to download file');
            }
          })
          .catch((error) => {
            console.error('Error:', error);
          });
      } else {
        console.error('loyaltyCardBarcode is not defined');
      }
    });
  }

  // https://apps.gloross.com/alchemista/ReduceShopifyAmount?cardNumber={0013}&amount={100}
  document.querySelector('#update-gift-card')?.addEventListener('submit', function (e) {
    e.preventDefault();

    const formData = new FormData(e.target);
    const lastChars = formData.get('last_chars');
    const sum = formData.get('sum');

    console.log(encodeURIComponent(lastChars));
    console.log(encodeURIComponent(sum));

    // Construct the URL using the form values
    const url = `https://apps.gloross.com/alchemista/ReduceShopifyAmount?cardNumber=${encodeURIComponent(
      lastChars
    )}&amount=${encodeURIComponent(sum)}`;

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        console.log('Success:', data);
        if (data.result == true) {
          document.querySelector('[data-response]').textContent = 'Успешно актуализирани средства';
        } else {
          document.querySelector('[data-response]').textContent = 'Неуспешно актуализирани средства';
        }

        // reset the form
        e.target.reset();
        // Handle successful response here
      })
      .catch((error) => {
        console.error('Error:', error);
        // Handle error here
      });
  });
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
